const UserFilters = ({ filters, setFilters }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <section className="rounded-lg border border-stone-200 bg-white">
      <div className="border-b border-stone-200 px-3 py-2">
        <h2 className="text-base font-semibold tracking-tight text-stone-950">Filters</h2>
      </div>
      <div className="grid grid-cols-1 gap-2 px-3 py-3 md:grid-cols-3">
        <FilterField label="Search" htmlFor="search">
          <input
            type="text"
            name="search"
            id="search"
            value={filters.search}
            onChange={handleChange}
            placeholder="Name or email…"
            className="ledger-input min-h-[38px]"
          />
        </FilterField>

        <FilterField label="Role" htmlFor="role">
          <select
            id="role"
            name="role"
            value={filters.role}
            onChange={handleChange}
            className="ledger-input min-h-[38px]"
          >
            <option value="all">All roles</option>
            <option value="admin">Admin</option>
            <option value="manager">Manager</option>
            <option value="instructor">Instructor</option>
            <option value="demonstrator">Demonstrator</option>
            <option value="student">Student</option>
          </select>
        </FilterField>

        <FilterField label="Status" htmlFor="status">
          <select
            id="status"
            name="status"
            value={filters.status}
            onChange={handleChange}
            className="ledger-input min-h-[38px]"
          >
            <option value="all">All statuses</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="pending">Pending</option>
          </select>
        </FilterField>
      </div>
    </section>
  );
};

const FilterField = ({ label, htmlFor, children }) => (
  <label htmlFor={htmlFor} className="block">
    <span className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-stone-500">
      {label}
    </span>
    {children}
  </label>
);

export default UserFilters;
